// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pm-list-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n.pm-list-form .form-no {\n  text-transform: uppercase;\n}\n.pm-list-form .actions {\n  display: flex;\n  gap: 10px;\n}\n.pm-list-form .actions * {\n  flex: 1;\n}", ""]);
// Exports
module.exports = exports;
